import _ from 'lodash';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ChampionsImportService {
    
  public takeUntilSubject: Subject<any> = new Subject();
  
  addFundraiserList(campaignId, fundraiserList, sendNotification) {
    const token = this.cookieService.get('accessToken');
    const queryParams = [
        `access_token=${token}`,
        `p=${encodeURIComponent(JSON.stringify({
          "campaignId": campaignId,
          "p2pList": fundraiserList,
          "sendNotification": sendNotification
        }))}`
    ];

    return this.http.post('/api/p2p/admin/create', _.join(queryParams, "&"), {
        headers: {
        'Content-Type': 'application/x-www-form-urlencoded'
        }
    });
  }

  constructor(
    private http: HttpClient,
    private cookieService: CookieService,
  ) { }
}
